import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PERMISSION_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { CustomTab } from '@/shared/ui/tab'
import { CustomTabs } from '@/shared/ui/tabs'

export const Route = createFileRoute('/_auth/journal/tabs')({
  staticData: {
    meta: {
      title: 'Пользователи АПК',
      description: '',
    },
  },
  component: RouteComponent,
})

type RouteName =
  | 'auth'
  | 'users'
  | 'students_and_parents'
  | 'employees'
  | 'reference_books'
  | 'canteen'
  | 'reports'
  | 'monitoring'
  | 'sessions'

const getTabFromPath = (pathname: string): RouteName => {
  if (pathname.includes('/journal/tabs/auth')) return 'auth'
  if (pathname.includes('/journal/tabs/users')) return 'users'
  // if (pathname.includes("/journal/tabs/students_and_parents"))
  //   return "students_and_parents";
  // if (pathname.includes("/journal/tabs/employees")) return "employees";
  // if (pathname.includes("/journal/tabs/reference_books"))
  //   return "reference_books";
  // if (pathname.includes("/journal/tabs/canteen")) return "canteen";
  // if (pathname.includes("/journal/tabs/reports")) return "reports";
  // if (pathname.includes("/journal/tabs/monitoring")) return "monitoring";
  // if (pathname.includes("/journal/tabs/sessions")) return "sessions";

  return 'auth'
}

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const tab = getTabFromPath(location.pathname)
  const [selectedTab, setSelectedTab] = useState<RouteName>(tab)

  const handleTabChange = (value: RouteName) => {
    setSelectedTab(value)
    navigate({ to: `/journal/tabs/${value}` })
  }

  return (
    <PermissionGuard permission={PERMISSION_MODULES.ADMINISTRATION}>
      <PageWrapper title={t('Журнал действий')}>
        <CustomTabs value={selectedTab} onChange={(_, value) => handleTabChange(value)}>
          <CustomTab value="auth" label={t('Авторизация')} />
          <CustomTab value="users" label={t('Пользователи и роли')} />
          <CustomTab disabled value="students_and_parents" label={t('Ученики и родители')} />
          <CustomTab disabled value="employees" label={t('Сотрудники')} />
          <CustomTab disabled value="reference_books" label={t('Справочники')} />
          <CustomTab disabled value="canteen" label={t('Столовая')} />
          <CustomTab disabled value="reports" label={t('Отчеты')} />
          <CustomTab disabled value="monitoring" label={t('Мониторинг')} />
          <CustomTab disabled value="sessions" label={t('Сессии')} />
        </CustomTabs>
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
